export const crmMessageSchedule = {
  notSelected: "Not selected",
  selectMessageGroup: "Select a message group from the list on the right",
  selectMessageGroupToChange:
    "To change it, select a message group from the list on the right",
  testSend: "Test Send",
};
